import { lazy } from "react";
import LazyLoad from "../common/LazyLoad";
import AdminLayout from "./AdminLayout";
import PrivateRoute from "./PrivateRoute";
import constants from "../common/constants";

const Dashboard = LazyLoad(lazy(() => import("../pages/dashboard")));
const Gallery = LazyLoad(lazy(() => import("../pages/gallery")));
const TrackingList = LazyLoad(lazy(() => import("../pages/tracking")));
const Profile = LazyLoad(lazy(() => import("../pages/profile")));
const MyPhotos = LazyLoad(lazy(() => import("../pages/myphotos")));
const { ADMIN, USER } = constants;

const AdminRoutes = {
  path: "/app",
  element: <AdminLayout />,
  children: [
    {
      path: "dashboard",
      element: <PrivateRoute element={<Dashboard />} requiredRole={ADMIN} />,
    },
    {
      path: "gallery",
      element: <PrivateRoute element={<Gallery />} requiredRole={ADMIN} />,
    },
    {
      path: "gallery/:folderId",
      element: <PrivateRoute element={<Gallery />} requiredRole={ADMIN} />,
    },
    {
      path: "tracking",
      element: <PrivateRoute element={<TrackingList />} requiredRole={ADMIN} />,
    },
    {
      path: "profile",
      element: <PrivateRoute element={<Profile />} allowedRoles={[ADMIN, USER]} />,
    },
    {
      path: "my-photos",
      element: <PrivateRoute element={<MyPhotos />} requiredRole={USER} />,
    },
  ],
};

export default AdminRoutes;
